module.exports = __webpack_public_path__ + "img/csa-logo.d7a76c9c.png";